import React from 'react';
import CONFIG from '../../../Config';

import ImagesPreview from './ImagesPreview';
import HuEmoji from '../../plugins/HuEmoji';
import '../../../../scss/components/plugins/hu-emoji.scss';

class InputText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      field: props.field,
      field_type: props.field_type,
      textSubmitHandler: props.textSubmitHandler,
      textareaData: props.textareaData,
      mode: 'text', // text | image
      text: props.textareaData.value ? this.getValue(props.textareaData.value) : '',
      empty: props.textareaData.value ? !this.getValue(props.textareaData.value) : true,
      images: [],
      image_flags: [],
    };
    this.fields = [
      'name', 'phone', 'email', 'postal code', 'address', 'country', 'birthdate',
    ];
    this.field_types = [
      'text', 'number', 'email', 'date', 'tel', 'location', 'image'
    ];
    this.input = null;
    this.imagesInput = null;
    this.inputContainer = null;
    this.buttonsContainer = null;
    this.emojiButton = null;
    this.emojisAttached = false;  // false or HuEmoji instance
    this.autocomplete = null;

    this.setInputFocus = this.setInputFocus.bind(this);
    this.setFocusWithChar = this.setFocusWithChar.bind(this);
    this.ee = props.ee;

    this.isIE = this.checkIE();
  }

  checkIE() {
    let ieversion = false;
    let detectIEregexp = null;
    if (navigator.userAgent.indexOf('MSIE') != -1)
      detectIEregexp = /MSIE (\d+\.\d+);/ //test for MSIE x.x
    else // if no "MSIE" string in userAgent
      detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/ //test for rv:x.x or rv x.x where Trident string exists

    if (detectIEregexp.test(navigator.userAgent)) //if some form of IE
      ieversion = parseInt(RegExp.$1);
    return ieversion;
  }

  getValue(value) {
    if (value.charAt(0) === '$')
      return temp_data[value.substring(1)] || '';
    return value;
  }

  getPlaceholder() {
    const fieldIndex = this.fields.indexOf(this.props.field);
    if (fieldIndex > -1)
      return CONFIG.text.inline_input_placeholder.replace('@field', CONFIG.text.fields[fieldIndex]);
    return CONFIG.text.text_input_placeholder;
  }

  onFocus(e) {
    if (this.inputContainer.className.indexOf('focus') === -1)
      this.inputContainer.className += ' focus';
  }

  onTextareaClick(e) {
    if (
      this.state.mode === 'text' && 
      this.buttonsContainer ? !this.buttonsContainer.contains(e.target) : true
    )
      this.setInputFocus();
  }

  onBlur() {
    if (this.input) {
      this.input.blur();
      this.inputContainer.className = this.inputContainer.className.replace(/\sfocus/g, '');
    }
  }

  onKeyDown(e) {
    const key = e.keyCode || e.which;
    if (key == 13) {
      if (!e.shiftKey) {
        e.preventDefault();
        if (!this.state.empty)
          this.send();
      } else { // contenteditable fixes
        e.preventDefault();
        const sel = window.getSelection();
        const caretNode = sel.anchorNode;
        const offset = sel.anchorOffset;
        const text = caretNode.textContent;
        const _text = text.slice(0, offset);
        const text_ = text.slice(offset) || ' ';
        caretNode.textContent = `${_text}
${text_}`;
        // Restore caret position
        const range = document.createRange();
        range.setStart(caretNode, offset + 1);
        range.setEnd(caretNode, offset + 1);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  }

  onInputKeyDown(e) {
    const key = e.keyCode || e.which;
    if (key == 13) {
      e.preventDefault();
      if (!this.state.empty) {
        this.send();
        const trash = document.querySelectorAll('.pac-container');
        for (let i = 0; i < trash.length; i++)
          trash[i].parentElement.removeChild(trash[i]);
      }
    }
  }

  onChange(e) {
    if (e.target)
      this.setState({
        text: typeof e.target.value === 'string' ? e.target.value : e.target.textContent,
        empty: typeof e.target.value === 'string' ? e.target.value === '' : e.target.textContent === '',
      });
    else if (typeof e === 'string' && document.activeElement === this.input) {
      this.setState({
        text: e,
        empty: e === '',
      });
    }
  }

  onPaste(e) {
    let text = '';
    if (window.clipboardData && window.clipboardData.getData)
      text = window.clipboardData.getData('Text');
    else
      text = e.clipboardData.getData('text/plain');
    document.execCommand('inserttext', false, text);
    e.preventDefault();
  }

  send() {
    if (this.emojisAttached)
      this.emojisAttached.hide();
    const { images, image_flags } = this.state;
    const text = this.input ? this.input.value || this.state.text : this.state.text;
    if (text === '' && images.length == 0)
      return;
    
    // Submit
    this.props.textSubmitHandler(text, images, image_flags);
    
    // Save temp variables
    if (this.props.textareaData.field)
      temp_data[this.props.textareaData.field] = text;

    this.setState({
      mode: 'text',
      text: '',
      empty: true,
      images: [],
      image_flags: [],
    });
    if (!this.props.fixed)
      this.onBlur();
  }

  setInputFocus() {
    if (this.input) {
      this.input.focus();
      this.input.click();
    }
  }

  setFocusWithChar(char) {
    if (document.activeElement !== this.input && this.input) {
      this.input.focus();
      this.onChange(`${this.state.text}${char}`);
    }
  }

  componentDidMount() {
    this.ee.on('hu-lb-input-focus', this.setInputFocus);
    this.ee.on('hu-lb-text-focus', this.setFocusWithChar);

    // Init Google Places Api
    if (this.props.field_type === 'location')
      this.initializeLocationAutocomplete();
  }

  componentWillUnmount() {
    this.ee.removeListener('hu-lb-input-focus', this.setInputFocus);
    this.ee.removeListener('hu-lb-text-focus', this.setFocusWithChar);
  }

  componentWillReceiveProps(nextProps) {
    if (this.input)
      this.input.focus();
    this.setState({
      mode: 'text',
      text: '',
      empty: true,
      images: [],
      image_flags: [],
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.field_type === 'location' &&
      prevProps.field_type !== 'location'
    )
      this.initializeLocationAutocomplete();
  }

  initializeLocationAutocomplete() {
    if (
      this.autocomplete !== null ||
      isMobile ||
      this.input instanceof HTMLInputElement === false
    ) return;
    this.autocomplete = new google.maps.places.Autocomplete(this.input);
    this.autocomplete.addListener('place_changed', () => {
      this.onChange(this.autocomplete.getPlace().formatted_address);
    });
  }
  
  attachImage(e) {
    if (e.target.files.length > 5)
      return;
    this.setState({
      empty: false,
      mode: 'image',
      images: e.target.files,
      image_flags: Array(this.imagesInput.files.length).fill(true),
    });
  }

  attachEmojis() {
    if (this.emojisAttached === false) {
      this.emojisAttached = new HuEmoji(
        this.input,
        this.emojiButton,
        // this.inputContainer,
        document.getElementById(this.props.emoji),
        {
          pages: ['People', 'Nature', 'Food', 'Activity', 'Travel', 'Objects', 'Symbols', 'Flags'],
          search: true,
          preview: true,
          height: '300px',
          positionX: 'right',
          positionY: 'bottom',
          offsetY: -285, // -305
          offsetX: 56,
          spritesUrl: 'https://storage.googleapis.com/static.helloumi.com/daisho/img/sprite-icons.png',
        }
      );
      this.emojisAttached.show();
    }
  }

  removeImage(key) {
    const { images, image_flags } = this.state;
    let noImagesLeft = false;
    let _image_flags = image_flags.slice();
    for (let i = 0; i < images.length; i++) {
      if (images[i].name === key) {
        _image_flags[i] = false;
      }
    }
    // If images_flags = [false, ...false]
    if (_image_flags.every((e) => !e))
      noImagesLeft = true;

    if (noImagesLeft) {
      this.setState({
        mode: 'text',
        empty: true,
        images: [],
        image_flags: _image_flags,
      });
      if (this.imagesInput)
        this.imagesInput.value = '';
    } else 
      this.setState({
        image_flags: _image_flags,
      });
  }

  render() {
    const { mode, text, empty, images, image_flags } = this.state;
    const { field, field_type } = this.props;
    let placeholder = this.getPlaceholder();
    const textareaType = this.fields.indexOf(field) > -1 ? 'hu-textarea-light' : 'hu-textarea-heavy';

    const specialType = (
      this.field_types.indexOf(field_type) > -1 &&
      ['text', 'image'].indexOf(field_type) === -1
    ) ? field_type : false;
    if (specialType === 'date') placeholder = '';

    const showImageInput = ['text', 'image'].indexOf(field_type) > -1 || this.props.fixed || false;

    const showEmojiInput = ['text'].indexOf(field_type) > -1 || this.props.fixed || false;

    const sendButton = (
      <button className="send" onClick={this.send.bind(this)} tabIndex={2}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" x="3650" y="3688">
          <path fill="" d="M1.1 21.757l22.7-9.73L1.1 2.3l.012 7.912 13.623 1.816-13.623 1.817-.01 7.912z"></path>
        </svg>
      </button>
    );
    const attachButton = (
      <div className="attach" tabIndex={3} onClick={() => {this.imagesInput.click()}}>
        <svg className="hu-fill_contrast" xmlns="http://www.w3.org/2000/svg" width="16" height="16" x="3650" y="3688" viewBox="0 0 35 30">
          <path fill="" d="M32.8,0c0.6,0,1.1,0.2,1.6,0.6C34.8,1,35,1.6,35,2.2v25.6c0,0.6-0.2,1.1-0.6,1.6C34,29.8,33.4,30,32.8,30 H2.2c-0.6,0-1.1-0.2-1.6-0.6C0.2,29,0,28.4,0,27.8V2.2C0,1.6,0.2,1,0.6,0.6C1,0.2,1.6,0,2.2,0H32.8z M23.8,15c0.4,0,0.8,0.2,1,0.5 l7.7,8.3V3.4c0-0.6-0.3-0.9-1-0.9h-28c-0.6,0-0.9,0.3-1,0.9v20.3l9.8-11.9c0.4-0.4,0.9-0.6,1.3-0.6c0.6,0,1,0.2,1.3,0.5l4.2,4.6 l0.3,0.3c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.9-0.4l1.4-1.2C23.1,15.1,23.4,15,23.8,15L23.8,15z M28.9,11.4 c-0.7,0.7-1.6,1.1-2.7,1.1c-1,0-1.9-0.4-2.7-1.1c-0.7-0.7-1.1-1.6-1.1-2.7c0-1,0.4-1.9,1.1-2.7C24.3,5.4,25.2,5,26.2,5 c1,0,1.9,0.4,2.7,1.1C29.6,6.8,30,7.7,30,8.8C30,9.8,29.6,10.7,28.9,11.4z"></path>
        </svg>
        <input 
          className="hide" 
          type="file"
          multiple="multiple"
          ref={(input)=> this.imagesInput = input}
          onChange={(e) => {this.attachImage(e);}}
        />
      </div>
    );
    const emojiButton = (
      <div className="emoji" tabIndex={4} onClick={this.attachEmojis.bind(this)} ref={(elem) => {this.emojiButton = elem;}}>
        <svg className="hu-fill_contrast" xmlns="http://www.w3.org/2000/svg" width="16" height="16" x="3650" y="3688" viewBox="0 0 34 34">
          <path fill="" d="M17.1,34.3C7.7,34.3,0,26.6,0,17.1S7.7,0,17.1,0s17.1,7.7,17.1,17.1S26.6,34.3,17.1,34.3z M17.1,2.9 C9.3,2.9,2.9,9.3,2.9,17.1s6.4,14.3,14.3,14.3S31.4,25,31.4,17.1S25,2.9,17.1,2.9z M11.4,14.3c-1.6,0-2.9-1.3-2.9-2.9 s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9S13,14.3,11.4,14.3z M17.1,27.1c-3.8,0-7.1-2.4-8.2-6c-0.2-0.8,0.2-1.5,0.9-1.8 c0.7-0.2,1.5,0.2,1.8,0.9c0.7,2.4,2.9,4,5.4,4s4.7-1.6,5.4-4c0.2-0.8,1-1.2,1.8-0.9c0.7,0.2,1.2,1,0.9,1.8 C24.2,24.7,20.9,27.1,17.1,27.1z M22.9,14.3c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9S24.4,14.3,22.9,14.3z"></path>
        </svg>
      </div>
    );

    let inputElement = null;
    if (mode === 'text')
      inputElement = ( !specialType && !this.isIE ?
        <div 
          className="hu-textarea hu-color_textarea-text"
          contentEditable={true}
          tabIndex={1}
          placeholder={placeholder}
          ref={(input) => {this.input = input;}}
          onInput={(e) => {this.onChange(e)}}
          onKeyDown={(e) => {this.onKeyDown(e)}}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          onPaste={this.onPaste}
          suppressContentEditableWarning
          data-gramm_editor="false"
        >
          {text}
        </div>
        :
        <input
          className="hu-textarea hu-color_textarea-text"
          contentEditable={true}
          tabIndex={1}
          placeholder={placeholder}
          ref={(input) => {this.input = input;}}
          onInput={(e) => {this.onChange(e)}}
          onChange={(e) => {this.onChange(e)}}
          onKeyDown={(e) => {this.onInputKeyDown(e)}}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          //onPaste={this.onPaste}
          //suppressContentEditableWarning
          data-gramm_editor="false"
          value={text}
          type={specialType}
        />
      );
    else if (mode === 'image') {
      inputElement = (
        <ImagesPreview
          images={images}
          image_flags={image_flags}
          removeImage={this.removeImage.bind(this)}
        />
      );
    }

    return (
      <div className={`${textareaType}${empty ? ' empty' : ''}`}>
        <div 
          className={`hu-textarea-input-container hu-background-color_textarea-background ${mode}`} 
          ref={(elem) => {this.inputContainer = elem;}}
          onClick={this.onTextareaClick.bind(this)}
        >
          {inputElement}
          <div 
            className="hu-textarea-buttons"
            ref={(elem) => {this.buttonsContainer = elem;}}
          >
            {sendButton}
            <div className="attachments">
              {showImageInput && attachButton}
              {this.props.emoji && showEmojiInput && emojiButton}
            </div>
          </div>
        </div>
        <div className="separator hu-background-color_inline-input"></div>
        <span className="hu-textarea-footer-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase">{ CONFIG.text.input_text_help }</span>
      </div>
    );
  }
}

export default InputText;


// WEBPACK FOOTER //
// ./app/js/components/messenger/input/InputText.js